import React, { useRef, useState } from "react";
import emailjs from "@emailjs/browser";

import { images } from "../../constants";
import { AppWrap, MotionWrap } from "../../wrapper";
import { client } from "../../client";
import "./Footer.scss";

const Footer = () => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    message: "",
  });
  const [isFormSubmitted, setIsFormSubmitted] = useState(false);
  const [loading, setLoading] = useState(false);

  const { name, email, message } = formData;

  const handleChangeInput = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleSubmit = () => {
    setLoading(true);

    const contact = {
      _type: "contact",
      name: name,
      email: email,
      message: message,
    };
    client.create(contact).then(() => {
      setLoading(false);
      setIsFormSubmitted(true);
    });
  };

  /* emailjs */
  const form = useRef();

  const sendEmail = (e) => {
    e.preventDefault();

    emailjs
      .sendForm(
        "service_nftg1b9",
        "template_pzaww2q",
        form.current,
        "hcpjyMeXKOSfKvMwR"
      )
      .then(
        (result) => {
          console.log(result.text);
        },
        (error) => {
          console.log(error.text);
        }
      );
  };

  return (
    <div className="app__footer">
      <div>
        <h2 className="head-text">
          Take a coffe <span>& </span>chat with me
        </h2>
        <p style={{ textAlign: "justify" }}>
          Feel free to contact me, use any of the links on this page, or use
          this contact form. I will get back to you as soon as possible. Thank
          you for taking the time to look at my portfolio.
        </p>
      </div>
      <div className="app__footer-cards">
        <div className="app__footer-card">
          <img src={images.email} alt="email" />
          <a href="mailto:barhoumi.ragheb@gmail.com" className="p-text">
            barhoumi.ragheb@gmail.com
          </a>
        </div>
        <div className="app__footer-card">
          <img src={images.mobile} alt="mobile" />
          <a href="+216 41 727 662" className="p-text">
            +216 41 727 662
          </a>
        </div>
      </div>
      <form
        className="app__footer-form app__flex"
        ref={form}
        onSubmit={sendEmail}
      >
        {/* form */}
        {!isFormSubmitted ? (
          <div className="app__footer-form app__flex">
            <div className="app__flex">
              <input
                className="p-text"
                type="text"
                placeholder="Your Name"
                name="from_name"
                defaultValue={name}
                onChange={handleChangeInput}
              />
            </div>
            <div className="app__flex">
              <input
                className="p-text"
                type="email"
                placeholder="Your Email"
                name="from_email"
                defaultValue={email}
                onChange={handleChangeInput}
              />
            </div>
            <div>
              <textarea
                className="p-text"
                placeholder="Your Message"
                name="message"
                defaultValue={message}
                onChange={handleChangeInput}
              />
            </div>
            <input type="submit" value={loading ? "Sending 💌" : "Send Message"} className="button" onClick={handleSubmit} />
          </div>
        ) : (
          <div>
            <h3 className="head-text">Thank you in getting in touch!</h3>
          </div>
        )}
      </form>
    </div>
  );
};

export default AppWrap(
  MotionWrap(Footer, "app_footer"),
  "contact",
  "app_whitebg"
);
